// EPN-98: must stay the FIRST import — aborts start-up before any Mock gateway is constructed when a
// production bundle is not explicitly real-backend. See shared/productionMockGuard.ts.
import './shared/productionMockGuard';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { IdentityProvider } from './features/identity/state/IdentityProvider';
import { ThemeProvider } from './shared/theme/ThemeProvider';
import './styles/app.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Outermost: theme applies to the whole app (including pre-auth screens like Sign In), independent
        of routing and auth state. */}
    <ThemeProvider>
      <BrowserRouter>
        <IdentityProvider>
          <App />
        </IdentityProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
